/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-param-reassign */
import React, { FC, useEffect, useState, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import Spinner from '@salesforce/design-system-react/components/spinner';
import DetailsHeader from '../../InventoryRequestDetail/DetailsHeader';
// import LineItems from './LineItems';
// import Comments from './Comments';
import Comments from '../../InventoryRequestDetail/Comments';
import { GET_TNVENTORY_REQUEST_DETAILS } from '../../../../graphql/getInventoryRequestDetails';
import { GET_FORM_CONFIGURATIONS } from '../../../../graphql/getFormConfigurations';
import SUBMIT_INVENTORY_DETAILS from '../../../../graphql/mutations/submitInventoryRequestDetails';
import CREATE_UPDATE_USAGE from '../../../../graphql/mutations/createdUpdateUsage';
import {
  INVENTORY_REQUEST_DETAIL_UI,
  INVENTORY_REQUEST_ASYNC_MESSAGES,
  NOTIFY_TYPE,
  OPS_ACTION_TYPE,
  WORKFLOW_ACTION,
  STALE_RECORD_MESSAGE,
  SYSTEM_NAME,
  DEFAULT_VERSION,
} from '../../../../util/constants';
import useSubmissionStatuses from '../hooks/useSubmissionStatuses';
import {
  shouldShowSubmissionInFlight,
  SubmissionStatusRecord,
} from '../../../../util/submissionStatus';
import { isStaleRecordError } from '../../../../util/optimisticLock';
import SnackBar from '../../../Shared/SnackBar';
import useSnackBar from '../../../../util/customHooks/useSnackBar';
import InventoryRequest from '../../InventoryRequest';
import { getUTCDateTime, checkRejectedItemsByOps } from '../../../../util/utilityFunctions';
import { GET_DETAILS_VIEW_CONFIGURATIONS } from '../../../../graphql/getDetailsViewConfigurations';
import CREATE_UPDATE_INVENTORY_FAVORITE from '../../../../graphql/mutations/createUpdateInventoryFavorites';
import { getUserInfo } from '../../../../store/ducks/userInfo';
import InventoryFavoriteSaveModal from '../../InventoryRequestDetail/FavoriteSaveConfirmationModal';
import { getUserId } from '../../../../store/ducks/userId';
import '../index.scss';
import CancelEventModal from '../../../CreateEditSurgeryEvent/CancelEventCreationModal';
import SaveConfirmationModal from './SaveConfirmationModal';
import AlreadyOrderedLinesModal, {
  BlockedOrderLine,
  BlockedOrderLineDisplay,
} from './AlreadyOrderedLinesModal';
import InventoryRequestDetailCatalog from '../../InventoryRequestDetail/InventoryRequestDetailCatalog';
import CancelInventory from '../../InventoryRequestCancel';

interface InventoryDetails {
  salesRep: string;
  eventStatus: string;
}

interface LineItems {
  productId: string;
  quantity: string;
  productNumber: string;
  workflowAction?: string;
  usageId?: string;
  viewOnly?: boolean;
  usageExternalId?: string;
}

const InventoryDetails: FC<RouteComponentProps> = ({ location, history }) => {
  const { state } = location;
  const [loading, setLoader] = useState(true);
  const [isEdit, setIsEdit] = useState(false);
  const [createUpdateUsage] = useMutation(CREATE_UPDATE_USAGE);
  const [canceModalVisible, setCanceModalVisible] = useState(false);
  const { open, notification, openSnackBar } = useSnackBar();

  const getCreateUpdateUsageErrorMessage = (err: any): string => {
    const errorMsg = err?.message?.toLowerCase() || '';
    if (errorMsg.includes('case is in new status')) {
      return 'Case is in New status, please resubmit it to Requested status.';
    }
    if (errorMsg.includes('case not assigned')) {
      return 'Case is not assigned to you, please assign it to yourself.';
    }
    if (errorMsg.includes('case assigned to another user error')) {
      return 'Case is assigned to another user. Please contact the assigned user.';
    }
    return 'Something went wrong. Please try again.';
  };

  const [getInventoryDetails, { data, refetch }] = useLazyQuery(GET_TNVENTORY_REQUEST_DETAILS, {
    fetchPolicy: 'no-cache',
  });
  const [getFormConfigurations, { data: formdata }] = useLazyQuery(GET_FORM_CONFIGURATIONS);
  const [inventoryRequestDetails, setInventoryRequestDetails] = useState<any>();
  const [submitInventoryRequestDetails] = useMutation(SUBMIT_INVENTORY_DETAILS);
  const [shipMethod, setShipMethod] = useState('');
  /*
   * The reviewer's per-line decisions, keyed by usageExternalId.
   *
   * The submit payload used to be built from the Apollo query result alone, and that result never
   * carries `userworkflowAction` (it is client-only). So the reviewer's choice only reached the
   * server if the autosave round-tripped first, and a decision made just before submit was sent as
   * whatever the server still had stored. Holding the decisions here means nothing derived from a
   * query response can discard them.
   *
   * Read through a ref as well, because submitIRDetails awaits the in-flight autosave and must not
   * read a stale render closure afterwards.
   */
  const [lineDecisions, setLineDecisions] = useState<Record<string, any>>({});
  const lineDecisionsRef = useRef<Record<string, any>>({});
  const latestDetailsRef = useRef<any>(null);
  /*
   * Autosave in-flight tracking. A counter rather than a boolean because rapid dropdown changes
   * overlap, and a boolean cleared by the first completion would open the gate while a later save
   * is still running. The promise is the full chain INCLUDING refetch, so awaiting it covers the
   * round trip rather than just the mutation.
   */
  const autosaveInFlightCountRef = useRef(0);
  const pendingAutosaveRef = useRef<Promise<unknown>>(Promise.resolve());
  const submitInFlightRef = useRef(false);
  // eslint-disable-next-line  @typescript-eslint/no-unused-vars
  const [userComment, setUserComment] = useState<any[]>();
  const [viewOnly, setViewOnly] = useState(false);
  const userInfo = useSelector(getUserInfo);
  const is3plOps = userInfo?.personas?.toLowerCase() === '3pl ops';
  const userId = useSelector(getUserId);
  const [isClone, setIsClone] = useState(false);
  const [FavName, setFavName] = useState('');
  const [isSave, setIsSave] = useState(false);
  const [isSavedModal, setSaveModal] = useState(false);
  const [isDataSaved, setIsDataSaved] = useState(true);
  const [reloadModal, setReloadModal] = useState(false);
  const [openInventoryCancelModal, setOpenInventoryCancelModal] = useState(false);
  /*
   * Lines the backend refused to re-arm because Salesforce had already ordered them. Held in state
   * rather than announced through the snackbar because the success path navigates away before its
   * own toast fires — see AlreadyOrderedLinesModal.
   */
  const [blockedOrderLines, setBlockedOrderLines] = useState<BlockedOrderLineDisplay[]>([]);
  const { data: getDetailsViewConfigurations } = useQuery(GET_DETAILS_VIEW_CONFIGURATIONS);
  const inventoryConfig =
    getDetailsViewConfigurations?.getDetailsViewConfigurations?.inventoryRequest;

  const [setInventoryFavorite] = useMutation(CREATE_UPDATE_INVENTORY_FAVORITE);

  useEffect(() => {
    lineDecisionsRef.current = lineDecisions;
  }, [lineDecisions]);

  useEffect(() => {
    if (data?.getInventoryRequestDetails) {
      latestDetailsRef.current = data.getInventoryRequestDetails;
    }
  }, [data]);

  const getLineKey = (line: any): string => line?.usageExternalId || '';

  /*
   * The single source of truth for "what did the reviewer decide about this line".
   * A held decision wins; otherwise fall back to whatever the server has stored.
   * Used by the validations AND the payload so they can never disagree — previously the
   * reject-comment guard read the stored value while the reviewer saw something else.
   */
  const resolveLineAction = (line: any, decisions: Record<string, any>): string => {
    const heldDecision = decisions?.[getLineKey(line)];
    if (Array.isArray(heldDecision) && heldDecision.length > 0) {
      return heldDecision[0].value;
    }
    return line?.workflowAction || WORKFLOW_ACTION.NO_ACTION;
  };

  const buildReviewedLines = (serverLines: any[], decisions: Record<string, any>): any[] =>
    (serverLines || []).map((line: any) => ({
      ...line,
      userworkflowAction: decisions?.[getLineKey(line)] || null,
      resolvedAction: resolveLineAction(line, decisions),
    }));

  useEffect(() => {
    getFormConfigurations();
  }, [getFormConfigurations]);
  useEffect(() => {
    if (state) {
      const { caseExternalId, opsAction } = state;
      if (caseExternalId) {
        if ((opsAction && opsAction !== OPS_ACTION_TYPE.REVIEW) || opsAction === 'Assign') {
          setViewOnly(true);
        }
        getInventoryDetails({
          variables: {
            externalId: caseExternalId,
          },
        });
      } else {
        // No external id -- navigate to list
        history.push('./Inventory/Review');
      }
    }
  }, [getInventoryDetails, history, state]);
  useEffect(() => {
    if (data && data.getInventoryRequestDetails) {
      setInventoryRequestDetails(data.getInventoryRequestDetails);
      setShipMethod(data.getInventoryRequestDetails.shipMethod || shipMethod);
      setLoader(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    const handleBeforeUnload = (e: any) => {
      if (!isDataSaved) {
        // Display your custom pop-up here
        setReloadModal(true);
        setSaveModal(true);
        const confirmationMessage = 'Changes that you made may not be saved.';

        // eslint-disable-next-line no-alert
        if (!window.confirm(confirmationMessage)) {
          // Prevent the page from unloading if the user cancels
          e.preventDefault();
          e.returnValue = '';
        }
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isDataSaved]);

  // const [finishstatus, setfinishstatus] = useState(false);

  // useEffect(() => {
  //   const onbackbuttonevent = (e: any) => {
  //     if (!isDataSaved) {
  //       e.preventDefault();
  //       if (!finishstatus) {
  //         setReloadModal(true);
  //         setSaveModal(true);
  //         // eslint-disable-next-line no-alert
  //         if (window.confirm('do you want to go back ?')) {
  //           setfinishstatus(true);
  //           history.goBack();
  //         } else {
  //           window.history.pushState(null, window.location.pathname);
  //           setfinishstatus(false);
  //         }
  //       }
  //     } else {
  //       history.goBack();
  //     }
  //   };
  //   if (!isDataSaved) {
  //     window.history.pushState(null, window.location.pathname);
  //   }
  //   window.addEventListener('popstate', onbackbuttonevent);
  //   return () => {
  //     window.removeEventListener('popstate', onbackbuttonevent);
  //   };
  // }, [isDataSaved]);

  const handleEditClick = () => {
    setIsEdit(true);
  };

  const saveLineData = (items: any): Promise<unknown> => {
    const { getInventoryRequestDetails: details } = data;
    const parts = items || details.lineItems;
    const filteredLineItems = parts?.filter(
      (item: any) => !checkRejectedItemsByOps(item, is3plOps)
    );
    const lineItemsPayload = filteredLineItems?.map((item: any) => {
      const {
        productId,
        quantity,
        productNumber,
        workflowAction,
        userworkflowAction,
        usageId,
        usageExternalId,
        actualQuantity,
        caseUsagesUpdatedByUser,
      } = item;
      const isUpdatedItem = Array.isArray(userworkflowAction) && userworkflowAction.length > 0;
      let action = isUpdatedItem ? userworkflowAction[0].value : WORKFLOW_ACTION.NO_ACTION;

      if (userworkflowAction === null || userworkflowAction === undefined) {
        action = workflowAction;
      }
      return {
        productId,
        actualQuantity,
        quantity,
        productNumber,
        usageId,
        usageExternalId,
        updatedByUser: isUpdatedItem ? userInfo?.id : caseUsagesUpdatedByUser,
        workflowAction: action === WORKFLOW_ACTION.APPROVE ? WORKFLOW_ACTION.ACCEPT : action,
      };
    });
    const payload = {
      caseId: details.caseId,
      caseExternalId: details.caseExternalId,
      accountId: details.accountId,
      branchId: details.branchId,
      salesRepId: details.salesRepId,
      shipToId: details.shipToId,
      serviceLevel: details.serviceLevel,
      needByDate: details.needByDate,
      shipMethod: shipMethod?.split('-')?.[0] || details?.shipMethod?.split('-')?.[0] || '',
      usageParts: lineItemsPayload,
      deliveryContractEmail: details.deliveryContractEmail,
      deliveryContractInstructions: details.deliveryContractInstructions,
      deliveryContractName: details.deliveryContractName,
      deliveryContractPhone: details.deliveryContractPhone,
      dockAvailable: details.dockAvailable,
      isShippingDetails: details.isShippingDetails,
      liftGateNeeded: details.liftGateNeeded,
      shortTruckOnly: details.shortTruckOnly,
      requestedFrom: 'Inventory',
      expectedCaseVersion: details.caseVersion,
    };
    setLoader(true);
    autosaveInFlightCountRef.current += 1;
    /*
     * refetch() is returned from both branches so it is part of the awaited chain. Previously
     * setLoader(false) ran before refetch() was even issued, so the UI unblocked while the
     * round trip was still in flight and a submit inside that window sent the pre-flip value.
     */
    pendingAutosaveRef.current = createUpdateUsage({
      variables: {
        ...payload,
        system: SYSTEM_NAME,
        version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
      },
    })
      .then((res: any) => {
        if (res && res.data && res.data.createUpdateUsage.message === 'success') {
          setTimeout(() => {
            openSnackBar(NOTIFY_TYPE.SUCCESS, 'Line Items submitted successfully');
          }, 1000);
        }
        return refetch ? refetch() : undefined;
      })
      .catch((err: any) => {
        setLoader(false);
        if (isStaleRecordError(err)) {
          openSnackBar(NOTIFY_TYPE.ERROR, STALE_RECORD_MESSAGE);
        } else {
          openSnackBar(NOTIFY_TYPE.ERROR, getCreateUpdateUsageErrorMessage(err));
        }
        return refetch ? refetch() : undefined;
      })
      .finally(() => {
        autosaveInFlightCountRef.current -= 1;
        if (autosaveInFlightCountRef.current === 0) {
          setLoader(false);
        }
      });

    return pendingAutosaveRef.current;
  };

  const setLineItemsPayload = (items: any): void => {
    /*
     * Retain the reviewer's decisions before autosaving. The table hands up the full line array
     * with userworkflowAction set on the line that changed; the query result that submit reads
     * never carries it, so without this the decision is only recoverable via the round trip.
     */
    const decisionsDelta: Record<string, any> = {};
    (items || []).forEach((item: any) => {
      const key = getLineKey(item);
      if (key && item?.userworkflowAction) {
        decisionsDelta[key] = item.userworkflowAction;
      }
    });
    if (Object.keys(decisionsDelta).length > 0) {
      setLineDecisions(previousDecisions => ({ ...previousDecisions, ...decisionsDelta }));
      lineDecisionsRef.current = { ...lineDecisionsRef.current, ...decisionsDelta };
    }
    saveLineData(items);
  };

  const setShipMethodValue = (item: string): void => {
    setIsDataSaved(false);
    setShipMethod(item);
    const { getInventoryRequestDetails: details } = data;

    if (details) {
      // const payload = {
      //   caseId: details.caseId,
      //   caseExternalId: details.caseExternalId,
      //   accountId: details.accountId,
      //   branchId: details.branchId,
      //   salesRepId: details.salesRepId,
      //   shipToId: details.shipToId,
      //   serviceLevel: details.serviceLevel,
      //   // needByDate: details.needByDate,
      //   shipMethod: item || details.shipMethod || '',
      //   deliveryContractEmail: details.deliveryContractEmail,
      //   deliveryContractInstructions: details.deliveryContractInstructions,
      //   deliveryContractName: details.deliveryContractName,
      //   deliveryContractPhone: details.deliveryContractPhone,
      //   dockAvailable: details.dockAvailable,
      //   isShippingDetails: details.isShippingDetails,
      //   liftGateNeeded: details.liftGateNeeded,
      //   requestedFrom: 'Inventory',
      // };
      // setLoader(true);
      // createUpdateUsage({
      //   variables: {
      //     ...payload,
      //   },
      // })
      //   .then((res: any) => {
      //     setLoader(false);
      //     if (res && res.data && res.data.createUpdateUsage.message === 'success') {
      //       setTimeout(() => {
      //         openSnackBar(NOTIFY_TYPE.SUCCESS, 'Shipping method updated successfully');
      //       }, 1000);
      //       refetch();
      //     }
      //   })
      //   .catch(() => {
      //     setLoader(false);
      //     openSnackBar(NOTIFY_TYPE.ERROR, 'Something went wrong. Please try again.');
      //   });
    }
  };

  const handleBackClick = () => {
    if (!isDataSaved) {
      setSaveModal(true);
    } else {
      history.goBack();
    }
  };

  const setUserEnteredComment = (comment: any): void => {
    setUserComment(comment);
  };

  const handleCancelButton = (): void => {
    setCanceModalVisible(!canceModalVisible);
  };

  const handleCancelModal = (): void => {
    setCanceModalVisible(!canceModalVisible);
  };

  const handleSavedModal = (): void => {
    setSaveModal(!isSavedModal);
    if (!reloadModal) {
      history.goBack();
    }
  };

  const handleCrossButtonModal = (): void => {
    setSaveModal(!isSavedModal);
  };

  const handleCancelModalConfirmPress = (): void => {
    setCanceModalVisible(!canceModalVisible);
    setIsEdit(!isEdit);
  };

  const handleSavedModalConfirmPress = (): void => {
    const { getInventoryRequestDetails: details } = data;
    let commentsPayload;
    if (userComment) {
      const commentArray = userComment.map(v => ({
        comment: v.value,
        postTime: getUTCDateTime(new Date()),
        commentType: 'Internal',
        externalId: v.externalId || null,
      }));
      commentsPayload = commentArray;
    }
    if (details) {
      const payload = {
        caseId: details.caseId,
        caseExternalId: details.caseExternalId,
        accountId: details.accountId,
        branchId: details.branchId,
        salesRepId: details.salesRepId,
        shipToId: details.shipToId,
        serviceLevel: details.serviceLevel,
        // needByDate: details.needByDate,
        shipMethod: shipMethod?.split('-')?.[0] || details?.shipMethod?.split('-')?.[0] || '',
        deliveryContractEmail: details.deliveryContractEmail,
        deliveryContractInstructions: details.deliveryContractInstructions,
        deliveryContractName: details.deliveryContractName,
        deliveryContractPhone: details.deliveryContractPhone,
        dockAvailable: details.dockAvailable,
        isShippingDetails: details.isShippingDetails,
        liftGateNeeded: details.liftGateNeeded,
        shortTruckOnly: details.shortTruckOnly,
        comments: commentsPayload,
        requestedFrom: 'Inventory',
        expectedCaseVersion: details.caseVersion,
        system: SYSTEM_NAME,
        version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
      };
      setLoader(true);
      createUpdateUsage({
        variables: {
          ...payload,
        },
      })
        .then((res: any) => {
          setLoader(false);
          if (res && res.data && res.data.createUpdateUsage.message === 'success') {
            setSaveModal(!isSavedModal);
            setTimeout(() => {
              openSnackBar(NOTIFY_TYPE.SUCCESS, 'Shipping method updated successfully');
            }, 1000);
            setIsDataSaved(true);
            if (!reloadModal) {
              history.goBack();
            }
          }
        })
        .catch(err => {
          setLoader(false);
          if (isStaleRecordError(err)) {
            openSnackBar(NOTIFY_TYPE.ERROR, STALE_RECORD_MESSAGE);
          } else {
            openSnackBar(NOTIFY_TYPE.ERROR, getCreateUpdateUsageErrorMessage(err));
          }
        });
    }
  };

  const handleModalToggle = useCallback((): void => {
    setIsEdit(!isEdit);
    setLoader(true);
  }, [isEdit]);

  /**
   * Joins each blocked line to what the screen already knows about it, so the reviewer sees a part
   * number instead of an identifier. Matched on usageExternalId, which the resolver guarantees is
   * non-null on every line this screen receives.
   */
  const describeBlockedLines = (blocked: BlockedOrderLine[]): BlockedOrderLineDisplay[] => {
    const onScreen = latestDetailsRef.current?.lineItems || details?.lineItems || [];
    return blocked.map(blockedLine => {
      const match = onScreen.find(
        (item: any) =>
          (!!blockedLine.usageExternalId &&
            item?.usageExternalId === blockedLine.usageExternalId) ||
          (!!blockedLine.usageId && item?.usageId === blockedLine.usageId)
      );
      return {
        ...blockedLine,
        productNumber: match?.productNo,
        productDescription: match?.productdescription,
      };
    });
  };

  /** The navigation the submit deferred while the reviewer read which lines were not sent. */
  const handleBlockedOrderLinesAcknowledged = (): void => {
    setBlockedOrderLines([]);
    history.push('/Inventory/Review');
  };

  const submitIRDetails = async (actionType = ''): Promise<void> => {
    // Guard a double-click: the submit is async now, so the handler can re-enter.
    if (submitInFlightRef.current) {
      return;
    }
    submitInFlightRef.current = true;
    setLoader(true);

    const abandonSubmit = (notifyType: string, message: string): void => {
      submitInFlightRef.current = false;
      setLoader(false);
      openSnackBar(notifyType, message);
    };

    /*
     * Never submit against state an in-flight autosave has not yet persisted. The chain includes
     * its own refetch, so this covers the round trip. A failed autosave must not take the submit
     * down with it — the decision is still held locally and remains submittable.
     */
    await pendingAutosaveRef.current.catch(() => undefined);

    const details = latestDetailsRef.current || data?.getInventoryRequestDetails;
    const decisions = lineDecisionsRef.current;
    const parts = buildReviewedLines(details?.lineItems, decisions);

    // Validation for no action performed in any line item
    const actionableItems = parts.filter(
      (item: any) =>
        item.workflowAction === WORKFLOW_ACTION.NO_ACTION || item.workflowAction === 'NoAction'
    );
    if (actionableItems?.length && actionType === '') {
      const notAttempted = actionableItems.find((i: any) => !i.userworkflowAction);
      if (notAttempted) {
        abandonSubmit(NOTIFY_TYPE.INFO, 'Please select an action for all line items');
        return;
      }
    }
    /*
     * Reads the resolved action, so a rejection made moments ago still requires a comment.
     * Reading the stored value here was the second half of the defect: inside the autosave
     * window this guard could not see the rejection it was meant to gate.
     */
    const rejectedItemFound = parts.find((i: any) => i.resolvedAction === WORKFLOW_ACTION.REJECT);
    // Validation for no comment provided in case of line item rejection
    if (
      (rejectedItemFound || actionType === 'cancelEvent') &&
      (userComment?.length === 0 || userInfo?.id !== userComment?.[0]?.userId)
    ) {
      abandonSubmit(NOTIFY_TYPE.INFO, 'Please provide comment for rejection');
      return;
    }
    // Validation for empty Ship Method
    if (!shipMethod) {
      abandonSubmit(NOTIFY_TYPE.INFO, 'Please Select Ship Method');
      return;
    }
    // Proceed to Submit
    const lineItemsPayload = parts.map((item: any) => {
      const { productId, quantity, productNumber, usageId, usageExternalId, resolvedAction } = item;
      return {
        productId,
        quantity,
        productNumber,
        usageId,
        usageExternalId,
        workflowAction:
          resolvedAction === WORKFLOW_ACTION.APPROVE ? WORKFLOW_ACTION.ACCEPT : resolvedAction,
      };
    });
    // let commentsPayload;
    // if (userComment?.length) {
    //   const commentArray = userComment.map(v => ({
    //     comment: v.value,
    //     postTime: getUTCDateTime(new Date()),
    //     commentType: 'Customer',
    //     externalId: v.externalId || null,
    //   }));
    //   commentsPayload = commentArray;
    // }
    const payload = {
      caseId: details.caseId,
      caseExternalId: details.caseExternalId,
      parentEventType: details.parentEventType,
      parentEventSubType: details.parentEventSubType,
      accountId: details.accountId,
      branchId: details.branchId,
      salesRepId: details.salesRepId,
      shipToId: details.shipToId,
      serviceLevel: details.serviceLevel,
      needByDate: details.needByDate,
      shipMethod: shipMethod?.split('-')?.[0] || details?.shipMethod?.split('-')?.[0] || '',
      lineItems: lineItemsPayload,
      isCancel: actionType === 'cancelEvent',
      cancelReason: actionType === 'cancelEvent' ? userComment?.[0]?.comment : '',
      // comments: commentsPayload,
      expectedCaseVersion: details.caseVersion,
      system: SYSTEM_NAME,
      version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
    };
    submitInventoryRequestDetails({
      variables: {
        ...payload,
      },
    })
      .then((res: any) => {
        setLoader(false);
        if (res && res.data && res.data.reviewInventoryRequest.message === 'success') {
          // Deliberately left locked: the screen navigates away below, and releasing here would
          // open a double-submit window for the second the navigation takes.
          const blocked: BlockedOrderLine[] =
            res.data.reviewInventoryRequest.blockedOrderLines || [];

          /*
           * Salesforce already turned these approved lines into order lines, so the backend refused
           * to send them a second time. That is correct, and it also means the reviewer's action was
           * a no-op for those lines. Hold the navigation and tell them which ones, because the toast
           * below fires three seconds AFTER this screen unmounts and would never be seen.
           */
          if (blocked.length > 0) {
            setBlockedOrderLines(describeBlockedLines(blocked));
            return;
          }

          setTimeout(() => {
            if (actionType === 'cancelEvent') {
              openSnackBar(NOTIFY_TYPE.SUCCESS, 'Success: Inventory successfully cancelled.');
            } else {
              openSnackBar(NOTIFY_TYPE.SUCCESS, 'Inventory details submitted successfully');
            }
          }, 4000);
          setTimeout(() => {
            history.push('/Inventory/Review');
          }, 1000);
          return;
        }
        submitInFlightRef.current = false;
      })
      .catch((error: any) => {
        submitInFlightRef.current = false;
        setLoader(false);
        if (isStaleRecordError(error)) {
          openSnackBar(NOTIFY_TYPE.ERROR, STALE_RECORD_MESSAGE);
        } else if (error?.message?.toLowerCase().includes('permission denied')) {
          openSnackBar(
            NOTIFY_TYPE.ERROR,
            'Submit is not allowed while user is on hold. Please contact Ops.'
          );
        } else {
          openSnackBar(NOTIFY_TYPE.ERROR, 'Something went wrong. Please try again.');
          refetch();
        }
      });
  };

  const handleSaveName = (e: any): void => {
    setFavName(e);
  };

  const handleSaveModalToggle = (): void => {
    setFavName('');
    setIsSave(!isSave);
  };

  const handleCloneModalToggle = useCallback((): void => {
    setIsClone(!isClone);
  }, [isClone]);

  const handlelSaveAsFavoriteModalConfirmPress = (): void => {
    setIsSave(!isSave);
    const items: any = [];
    if (
      inventoryRequestDetails &&
      inventoryRequestDetails.lineItems &&
      inventoryRequestDetails.lineItems.length > 0
    ) {
      // eslint-disable-next-line array-callback-return
      inventoryRequestDetails.lineItems.map((el: any) => {
        const obj = {
          part: {
            id: el.productId,
            name: `${el.productNo} ${el.productdescription}`,
          },
          lotNumber: '',
          quantity: el.quantity,
        };
        items.push(obj);
      });
    }
    const commentsArray: any = [];
    if (
      inventoryRequestDetails &&
      inventoryRequestDetails.comments &&
      inventoryRequestDetails.comments.length > 0
    ) {
      inventoryRequestDetails.comments.map((el: any) => {
        const obj = {
          comment: el.value,
          postTime: el.postTime,
          commentType: el.type,
          externalId: el.externalId,
        };
        commentsArray.push(obj);
      });
    }
    const finalObject = {
      nameOfFavorite: FavName,
      recordType: 'create',
      userId,
      serviceLevel: inventoryRequestDetails.serviceLevel,
      salesRep: {
        name: inventoryRequestDetails.salesRep,
        id: inventoryRequestDetails.salesRepId,
      },
      comments: commentsArray,
      account: {
        id: inventoryRequestDetails.accountId,
        name: `${inventoryRequestDetails.accountName}-${inventoryRequestDetails.accountNumber}`,
      },
      shipTo: {
        id: inventoryRequestDetails.shippingId,
        name: `${inventoryRequestDetails.shippingAddessLine1},${
          inventoryRequestDetails.shippingAddessLine2
            ? inventoryRequestDetails.shippingAddessLine2
            : ''
        },${inventoryRequestDetails.shippingCity},${inventoryRequestDetails.shippingState},${
          inventoryRequestDetails.shippingPostalcode
        }`,
      },
      lineItems: items,
    };

    setInventoryFavorite({
      variables: finalObject,
    }).catch(error => {
      const errMsg = error.message.split(':')[1] || 'Something went wrong. Please try again.';
      openSnackBar(NOTIFY_TYPE.ERROR, errMsg);
      // eslint-disable-next-line no-console
      console.log(error); // TODO change when some operation needs to be run on error.
    });
  };

  const handleInventoryActionDropdownSelect = (option: any): void => {
    if (option && option.value) {
      if (option.value.toLowerCase() === 'submit' && !option.disabled) {
        if (option.disabledReason === 'missing_line_items') {
          openSnackBar(NOTIFY_TYPE.ERROR, 'Please add the parts for the Inventory and submit');
        } else {
          submitIRDetails();
        }
      } else if (option.value.toLowerCase() === 'edit' && !option.disabled) {
        setIsEdit(true);
      } else if (option.value.toLowerCase() === 'clone' && !option.disabled) {
        setIsClone(true);
      } else if (option.value.toLowerCase() === 'make_favorite' && !option.disabled) {
        setIsSave(!isSave);
      } else if (option.value.toLowerCase() === 'cancel_request' && !option.disabled) {
        setOpenInventoryCancelModal(!openInventoryCancelModal);
      } else if (option.value.toLowerCase() === 'discrepancy') {
        // eslint-disable-next-line no-unused-expressions
        userInfo?.businessRules.forEach((br: any) => {
          if (br.rules === 'Inventory Discrepancy Email Recipient') {
            window.open(
              `mailto: ${br.values}?subject=Inventory Request: ${inventoryRequestDetails.eventId}&body=`
            );
          }
        });
      }
    }
  };

  const handleCancelInventoryModal = (): void => {
    setOpenInventoryCancelModal(!openInventoryCancelModal);
  };

  const cancelInventory = (): void => {
    submitIRDetails('cancelEvent');
    setOpenInventoryCancelModal(!openInventoryCancelModal);
  };

  const handleRequestClick = (
    parentEventType: any,
    parentCaseExternalId: any,
    parentEventId: any
  ): void => {
    if (window.location.pathname !== '/surgicalDetails') {
      history.push('/surgicalDetails', {
        eventType: parentEventType,
        externalId: parentCaseExternalId,
        id: parentEventId,
      });
    }
  };

  const { caseExternalId, opsAction } = state;
  const { submissionStatusByCase, error: submissionStatusError } = useSubmissionStatuses(
    [caseExternalId].filter(Boolean),
    opsAction?.toUpperCase() === 'REVIEW'
  );
  const submissionStatusRecord: SubmissionStatusRecord | undefined =
    submissionStatusByCase[caseExternalId];
  const isSubmissionInFlight = shouldShowSubmissionInFlight(
    submissionStatusRecord,
    INVENTORY_REQUEST_DETAIL_UI.SUBMISSION_RECOVERY_MAX_AGE_MS
  );
  const lastSubmissionStatusErrorRef = useRef<string | null>(null);

  useEffect(() => {
    if (submissionStatusError) {
      const errorKey = submissionStatusError.message || 'submission-status-query-error';
      if (lastSubmissionStatusErrorRef.current !== errorKey) {
        openSnackBar(NOTIFY_TYPE.ERROR, INVENTORY_REQUEST_ASYNC_MESSAGES.STATUS_QUERY_ERROR);
        lastSubmissionStatusErrorRef.current = errorKey;
      }
    } else {
      lastSubmissionStatusErrorRef.current = null;
    }
  }, [submissionStatusError, openSnackBar]);

  const visualIndicator = inventoryRequestDetails ? inventoryRequestDetails.visualIndicator : '';
  const eventStatus = inventoryRequestDetails?.parentEventStatus || '';

  return (
    <IconSettings iconPath="/icons">
      <SnackBar open={open} notification={notification} />
      {loading && <Spinner />}
      {inventoryRequestDetails && (
        <>
          {/* <DetailsHeader
            inventoryDetails={inventoryRequestDetails}
            setShipMethodValue={setShipMethodValue}
            viewOnly={viewOnly}
            submitIRDetails={submitIRDetails}
            handleEditClick={handleEditClick}
          /> */}
          <DetailsHeader
            inventoryReturnDetails={inventoryRequestDetails}
            setShipMethodValue={setShipMethodValue}
            handleEditClick={handleEditClick}
            handleRequestClick={handleRequestClick}
            viewOnly={viewOnly}
            userInfo={userInfo}
            type={state?.opsAction}
            handleInventoryActionDropdownSelect={handleInventoryActionDropdownSelect}
            irHeaderCofig={inventoryConfig?.headers}
            handleBackClick={handleBackClick}
            isSubmissionInFlight={isSubmissionInFlight}
          />
          {/* <LineItems
            inventoryDetails={inventoryRequestDetails}
            handleLineItemActions={setLineItemsPayload}
            viewOnly={viewOnly}
            setShowSearchCatalogModal={setShowSearchCatalogModal}
          /> */}

          <InventoryRequestDetailCatalog
            refetch={refetch}
            inventoryDetail={inventoryRequestDetails}
            isEventInventoryFlow={false}
            visualIndicator={visualIndicator}
            parentEventStatus={eventStatus}
            type={opsAction}
            hasEventInventory={false}
            eventInventoryExternalId={inventoryRequestDetails?.parentCaseExternalId || ''}
            externalId={caseExternalId}
            changeSelectedTab={() => {}}
            tabConfig={inventoryConfig}
            viewOnly={!!(viewOnly || opsAction === 'Assign')}
            handleLineItemActions={setLineItemsPayload}
          />
          <Comments
            inventoryReturnDetails={inventoryRequestDetails}
            setUserEnteredComment={setUserEnteredComment}
            viewOnly={false}
            type={opsAction}
          />
        </>
      )}
      {isEdit && (
        <InventoryRequest
          isOpen={isEdit}
          inventoryDetail={inventoryRequestDetails}
          toggleOpen={handleModalToggle}
          formData={formdata}
          type="Open"
          refetch={refetch}
          eventType="Request Inventory"
          handleCancelButton={handleCancelButton}
        />
      )}
      {/* {canceModalVisible && (
        <CancelEventModal
          canceModalVisible={canceModalVisible}
          handleCancelModal={handleCancelModal}
          handleCancelModalConfirmPress={handleCancelModalConfirmPress}
          edit={isEdit}
        />
      )} */}
      {isClone && (
        <InventoryRequest
          isClone={isClone}
          isOpen={isClone}
          inventoryDetail={inventoryRequestDetails}
          toggleOpen={handleCloneModalToggle}
          formData={formdata}
          refetch={refetch}
          eventType="Request Inventory"
        />
      )}
      {isSave && (
        <InventoryFavoriteSaveModal
          favName={FavName}
          handleSaveName={handleSaveName}
          showEditConfirmationModal={isSave}
          handleModalToggle={handleSaveModalToggle}
          handlelSaveFavoriteModalConfirmPress={handlelSaveAsFavoriteModalConfirmPress}
        />
      )}
      {openInventoryCancelModal && (
        <CancelInventory
          cancelInventoryModalVisible={openInventoryCancelModal}
          handleCancelInventoryModal={handleCancelInventoryModal}
          eventId={inventoryRequestDetails?.eventId}
          eventType={inventoryRequestDetails?.eventType}
          cancelInventory={cancelInventory}
          cancelInventoryLoading={loading}
        />
      )}
      {canceModalVisible && (
        <CancelEventModal
          canceModalVisible={canceModalVisible}
          handleCancelModal={handleCancelModal}
          handleCancelModalConfirmPress={handleCancelModalConfirmPress}
          edit={isEdit}
        />
      )}
      {isSavedModal && (
        <SaveConfirmationModal
          reloadModal={reloadModal}
          canceModalVisible={isSavedModal}
          handleCancelModal={handleSavedModal}
          handleCrossButtonModal={handleCrossButtonModal}
          handleCancelModalConfirmPress={handleSavedModalConfirmPress}
          edit={isEdit}
        />
      )}
      {blockedOrderLines.length > 0 && (
        <AlreadyOrderedLinesModal
          isOpen
          blockedLines={blockedOrderLines}
          onAcknowledge={handleBlockedOrderLinesAcknowledged}
        />
      )}
    </IconSettings>
  );
};

export default withRouter(InventoryDetails);
